import React from "react";
import ContentLoader from "react-content-loader";

const PizzaSkeleton = (props) => (
  <ContentLoader
    className="pizza-block "
    speed={2}
    width={280}
    height={466}
    viewBox="0 0 280 466"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <circle cx="130" cy="120" r="120" />
    <rect x="0" y="264" rx="10" ry="10" width="280" height="30" />
    <rect x="0" y="424" rx="10" ry="10" width="108" height="36" />
    <rect x="0" y="312" rx="10" ry="10" width="280" height="90" />
    <rect x="118" y="421" rx="17" ry="17" width="160" height="45" />
  </ContentLoader>
);

export default PizzaSkeleton;
